import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { JSX, useEffect, useRef } from "react";
import { updateDossier } from "../../../app/rootReducer";
import { BovagTermsTypeEnum } from "../../../common/constants/BovagTermsTypeEnum";
import { setVehicleUsage } from "../vehicleInformationSlice";
import { PatchStepsEnum } from "../../../common/constants/PatchStepsEnum";
import { scheduleScrollToStep } from "../../../common/helpers/scrollToStep";
import { setGeneralStep } from "../../helpType/helpTypeSlice";
import { GeneralStepsEnum } from "../../../common/constants/GeneralStepsEnum";

const VehicleInformationCaravanUsage = (): JSX.Element | null => {
    const dispatch = useAppDispatch();
    const { vehicleUsage } = useAppSelector(
        (state) => state.vehicleInformation,
    );
    const { dossier } = useAppSelector((state) => state.root);
    const scrollRef = useRef<HTMLDivElement>(null);

    const renderCondition = dossier?.car_brand && dossier?.car_model;

    useEffect(() => {
        if (!renderCondition) return;
        scheduleScrollToStep(() => scrollRef.current);
    }, [renderCondition]);

    const handleVehicleUsageChange = (usage: BovagTermsTypeEnum): void => {
        dispatch(setVehicleUsage(usage));
        dispatch(
            updateDossier({
                data: { bovag_terms_type: usage },
                method: PatchStepsEnum.PatchBovagTermsType,
            }),
        ).then(() => {
            dispatch(setGeneralStep(GeneralStepsEnum.Appointment));
        });
    };

    if (!renderCondition) {
        return null;
    }

    return (
        <div
            className="s-appointment__group border-color-primary"
            ref={scrollRef}
        >
            <h1 className="s-appointment__group__title">
                Is je camper of caravan zakelijk of privé in gebruik?
            </h1>
            <div className={"c-input__group"}>
                <div className="c-form__buttons c-form__buttons--row c-form__buttons--no-margin">
                    <button
                        className={`c-form__buttons__single border-color-primary border-color-primary-hover ${vehicleUsage === BovagTermsTypeEnum.BUSINESS ? "button-active" : ""}`}
                        type={"button"}
                        onClick={() =>
                            handleVehicleUsageChange(
                                BovagTermsTypeEnum.BUSINESS,
                            )
                        }
                    >
                        <span className="font-face-primary">Zakelijk</span>
                    </button>
                    <button
                        className={`c-form__buttons__single border-color-primary border-color-primary-hover ${vehicleUsage === BovagTermsTypeEnum.PRIVATE ? "button-active" : ""}`}
                        type={"button"}
                        onClick={() =>
                            handleVehicleUsageChange(BovagTermsTypeEnum.PRIVATE)
                        }
                    >
                        <span className="font-face-primary">Privé</span>
                    </button>
                </div>
                <p>
                    Zo tonen we de juiste BOVAG-voorwaarden voor jouw situatie
                </p>
            </div>
        </div>
    );
};

export default VehicleInformationCaravanUsage;
